import { MasterConfig } from 'ui-shared';
import { EnumRoles, Rules } from './features/compartilhado/roles-guard/rules';
import { environment } from "@env/environment";
//forca deploy 1
export const masterConfiguracao = (ambiente: string) => {
    return {
        permicaoAmbiente: environment.permissaoAmbiente,
        modulo: "906B8B89-C57C-4896-B85C-B90EAA8C6482",
        multiConta: true,
        titulo: 'Classificação Fiscal - Configuração',
        rota: '/config/home',
        imgUrl: '../assets/AF_ICONE_BLUE_ROUTE_WHITE.png',
        ambiente: ambiente,
        links: [
            { titulo: 'Home', icone: 'home', label: 'Home', rota: 'home' },
            {
                titulo: 'Configuracoes', icone: 'settings', label: 'Configurações', links: [
                    { titulo: 'Parâmetros', icone: 'tune', label: 'Parâmetros', rota: 'parametro-valor' }
                ]
            },
            {
                titulo: 'Consultas', icone: 'search', label: 'Consultas', links: [
                    {
                        titulo: 'NCM',
                        icone: 'description',
                        label: 'NCM',
                        rota: 'ncm'
                    }
                ]
            },
            {
                titulo: 'Cadastro', icone: 'source', label: 'Cadastro', links: [
                    { titulo: 'NCM', icone: 'description', label: 'NCM', rota: 'ncm-manutencao' },
                    { titulo: 'Parâmetros', icone: 'settings', label: 'Parâmetros', rota: 'parametros' },
                    { titulo: 'Clientes', icone: 'group', label: 'Clientes', rota: 'clientes' },
                    { titulo: 'Notificações', icone: 'notifications', label: 'Notificações', rota: 'notificacoes' },
                    { titulo: 'Relatórios', icone: 'description', label: 'Relatórios', rota: 'relatorios' },
                    { titulo: 'Solicitações', icone: 'manage_history', label: 'Solicitações Processamento', rota: 'solicitacao-processamento' },
                ]
            },
        ],
    } as MasterConfig
};

export const masterSemContaEmUso = {
    permicaoAmbiente: environment.permissaoAmbiente,
    modulo: "906B8B89-C57C-4896-B85C-B90EAA8C6482",
    multiConta: true,
    titulo: 'Classificação Fiscal',
    imgUrl: '../assets/AF_ICONE_BLUE_ROUTE_WHITE.png',
    links: [
        { titulo: 'Home', icone: 'home', label: 'Home', rota: 'home' }
    ],
} as MasterConfig;

export const masterOperacao = (rules: Rules, accessToken: string, ambiente: string, iconeDespachante?: string) => {
    return {
        permicaoAmbiente: environment.permissaoAmbiente,
        modulo: "906B8B89-C57C-4896-B85C-B90EAA8C6482",
        multiConta: true,
        notificacao: true,
        titulo: 'Classificação Fiscal',
        rota: '/home',
        imgUrl: '../assets/AF_ICONE_BLUE_ROUTE_WHITE.png',
        ambiente: ambiente,
        iconeDespachante: iconeDespachante ? iconeDespachante : '',
        links: [
            {
                titulo: 'Classificação', icone: 'fact_check', label: 'Classificação', rota: '/classificacao',
                // A fila exige Detalhes (como a exportação)
                disable: !rules.possuiPermissao(EnumRoles.Detalhes)
            },
            {
                titulo: 'Configuracoes', icone: 'settings', label: 'Configurações', links: [
                    {
                        titulo: 'Ações por Status',
                        icone: 'rule',
                        label: 'Ações por Status',
                        rota: '/acao-status',
                        disable: !rules.possuiPermissao(EnumRoles.Administrador)
                    },
                    {
                        titulo: 'Parâmetro Operacao Valor',
                        icone: 'tune',
                        label: 'Parâmetros',
                        rota: '/parametro-operacao-valor',
                        disable: !rules.possuiPermissao(EnumRoles.Administrador)
                    },
                    {
                        titulo: 'Gestão de Usuário',
                        icone: 'lock',
                        label: 'Gestão de Usuário',
                        rota: '/gestao-usuario',
                        disable: !(rules.possuiPermissao(EnumRoles.Administrador) || rules.possuiPermissao(EnumRoles.GestaoUsuario))
                    }
                ]
            },
            {
                titulo: 'Consultas', icone: 'search', label: 'Consultas', links: [
                    {
                        titulo: 'NCM',
                        icone: 'description',
                        label: 'NCM',
                        rota: '/ncm'
                    }
                ]
            },
            {
                titulo: 'Cadastros', icone: 'source', label: 'Cadastros', links: [
                    {
                        titulo: 'Produto',
                        icone: 'inventory',
                        label: 'Produto',
                        rota: '/produto',
                        disable: !rules.possuiPermissao(EnumRoles.Detalhes)
                    },
                    // Sem o controle por projeto ligado, ou sem a permissão de cadastro de projeto, o menu não aparece.
                    ...(rules.projetosHabilitados ? [{
                        titulo: 'Projetos',
                        icone: 'work',
                        label: 'Projetos',
                        rota: '/projeto'
                    }] : []),
                    {
                        titulo: 'Perfis',
                        icone: 'badge',
                        label: 'Perfis',
                        rota: '/perfil-acesso',
                        disable: !rules.possuiPermissao(EnumRoles.GestaoUsuario)
                    },
                    {
                        titulo: 'Importação de Dados',
                        icone: 'publish',
                        label: 'Importação de Dados',
                        rota: '/importacao-dados',
                        disable: !rules.possuiPermissao(EnumRoles.CadastroProduto)
                    },
                ]
            },
            { titulo: 'Relatórios', icone: 'area_chart', label: 'Relatórios', rota: '/relatorio' },
        ],
        usuarioLinks: [
            { titulo: 'Configurações', icone: 'tune', label: 'Configurações', rota: 'usuario/configuracao' }
        ],
    } as MasterConfig;
}
